<template>
    <div class="col-md-12 panel">
                <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>
                <div class="row">
                    <div class="col-md-12">
                        <div class="panel">
                            <div class="panel-heading">
                                <div class="panel-title hidden-xs">
                                    <span class="glyphicon glyphicon-tasks"></span>Эффективность администраторов <span
                                        id="instructor_name"></span></div>
                            </div>
                            <form v-on:submit.prevent="getReport" class="ng-pristine ng-valid">
                                <div class="panel-body ">
                                    <div class="col-md-4">
                                        <input type="date" v-model="filter.from" class="form-control"
                                               value="" placeholder="Начало периода" required="">
                                    </div>
                                    <div class="col-md-4">
                                        <input type="date" v-model="filter.to" class="form-control"
                                               value="" placeholder="Конец периода" required="">
                                    </div>

                                </div>
                                <div class="panel-footer">
                                    <button type="submit" class="btn btn-primary getstat"> Показать </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="section row" v-if="rows.length > 0">
                    <div class="col-md-12">
                        <div class="panel panel-visible">

                            <div class="panel-body pn">
                                <table class="table table-striped table-hover datatables table-fixed-header" cellspacing="0" width="100%">
                                    <thead>
                                    <tr>
                                        <th>Администратор</th>
                                      <th>
                                        <abbr title="">
                                          Всего лидов - неназначенных никому<br>(ч-к)
                                        </abbr>
                                      </th>
                                        <th>
                                          <abbr title="Назначено лидов этому админу">
                                            Назначено лидов<br>(ч-к)
                                        </abbr>
                                        </th>
                                        <th>
                                          <abbr title="(ч-к) у этого админа в статусе запись">
                                            Записаны на пробное<br>(ч-к)
                                          </abbr>
                                        </th>
                                      <th>
                                        <abbr title="(ч-к) у этого админа в статусе перворазник">
                                          Купили 1 занятие)<br>(ч-к)
                                        </abbr>
                                      </th>
                                      <th>
                                        <abbr title="Купили абонемент">
                                          Купили абонемент<br>(ч-к)
                                        </abbr>
                                      </th>
                                      <th>
                                        <abbr title="(Все Деньги, поступившие от лидов данного админа)">
                                          Объем продаж по админу<br>(руб.)
                                        </abbr>
                                      </th>
                                      <th>
                                        <abbr title="(Объем продаж именно этого админа (руб.) / на Общий объем продаж (руб.)) и умножить на 100)">
                                          Доля в общем объеме продаж<br>(%)
                                        </abbr>
                                      </th>
                                      <th>
                                        <abbr title="Объем продаж именно этого админа (руб.)/Купили абонемент у этого админа (ч-к)">
                                          Средний чек каждого админа<br>(руб.)
                                        </abbr>
                                      </th>
                                      <th>
                                        <abbr title="(купили абонемент (ч-к) / назначено лидов (ч-к) данному менеджеру) и умножить на 100 процентов)">
                                          Финальный CR по каждому админу<br>(%)
                                        </abbr>
                                      </th>
                                      <th>
                                        <abbr title="купили абонемент (ч-к) суммарно по всем админам / всего лидов (ч-к) и умножить на 100 процентов">
                                          Финальный CR средний<br>(%)
                                        </abbr>
                                      </th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(row, index) in rows" v-bind:key="index">
                                        <td>{{row.name}}</td>
                                        <td class="sum-cell">{{row.total_not}}</td>
                                        <td class="sum-cell">{{row.total}}</td>
                                        <td class="sum-cell">{{row.to_record}}</td>
                                        <td class="sum-cell">{{row.to_first}}</td>
                                        <td class="sum-cell">{{row.to_active}}</td>
                                        <td class="sum-cell">{{row.all_money}}</td>
                                        <td class="sum-cell">{{row.personal_persent_money | numberFormat(2)}}</td>
                                        <td class="sum-cell">{{row.avg_sale_by_admin | numberFormat()}}</td>
                                        <td class="sum-cell">{{row.final_personal | numberFormat()}}</td>
                                        <td class="sum-cell">{{row.final_personal_all | numberFormat(2)}}</td>
                                    </tr>
                                    <tr >
                                      <td><strong>Итого:</strong></td>
                                      <td class="sum-cell"></td>
                                      <td class="sum-cell"><strong>{{total.lids | numberFormat()}}</strong></td>
                                      <td class="sum-cell"><strong>{{total.to_record | numberFormat()}}</strong></td>
                                      <td class="sum-cell"><strong>{{total.to_first | numberFormat()}}</strong></td>
                                      <td class="sum-cell"><strong>{{total.to_active | numberFormat()}}</strong></td>
                                      <td class="sum-cell"><strong>{{total.all_money | numberFormat(2)}}</strong></td>
                                      <td class="sum-cell"><strong>{{total.personal | numberFormat(2)}}</strong></td>
                                      <td class="sum-cell"><strong></strong></td>
                                      <td class="sum-cell"></td>
                                      <td class="sum-cell"></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

    </div>
</template>

<script>
    import Report from "../../classes/api/Report";
    import moment from 'moment';

    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
        },
        mounted() {
            this.getReport();
        },
        computed: {
          total: function() {
            let total = {
              lids: 0,
              to_record: 0,
              to_first: 0,
              to_active: 0,
              all_money: 0,
              avg_money: 0,
              personal: 0,
            };
            for (let row of this.rows) {
              total.lids += row.total
              total.to_record += parseInt(row.to_record)
              total.to_first += parseInt(row.to_first)
              total.to_active += parseInt(row.to_active)
              total.all_money += parseInt(row.all_money)
              total.avg_money += parseInt(row.avg_sale_by_admin)
              total.personal += parseInt(row.personal_persent_money)
            }
            total.avg_money = total.avg_money/this.rows.length
            return total;
          },
        },
        data() {
            return {
                isLoading: false,
                filter: {
                    from: moment().format('YYYY-MM-01'),
                    to: moment().format('YYYY-MM-DD'),
                },
                rows: [],
            };
        },
        methods: {
            async getReport() {
                this.isLoading = true;
                let response = await Report.getAdminEfficiency(this.filter.from, this.filter.to);
                this.rows = response.data;
                this.isLoading = false;
            },
        },
        metaInfo() {
            return {
                title: 'Отчеты - эффективность администраторов',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
